import { Plugin } from '@tiptap/pm/state';
export class EnforceSingleNodePlugin extends Plugin {
    constructor(nodeType) {
        super({
            filterTransaction(transaction) {
                const transactionResultContains = EnforceSingleNodePlugin.countNodesOfType(transaction.doc, nodeType, 2);
                if (transactionResultContains > 1) {
                    return false;
                }
                return true;
            },
        });
    }
    static countNodesOfType(doc, nodeType, earlyExitAtCount) {
        let count = 0;
        doc.descendants((node) => {
            if (earlyExitAtCount !== undefined && count === earlyExitAtCount) {
                return false;
            }
            if (node.type.name === nodeType) {
                count += 1;
            }
        });
        return count;
    }
}
//# sourceMappingURL=enforce-single-node.js.map